import { render, staticRenderFns } from "./LocaleEditDialog.vue?vue&type=template&id=558a7815&scoped=true"
import script from "./LocaleEditDialog.vue?vue&type=script&lang=js"
export * from "./LocaleEditDialog.vue?vue&type=script&lang=js"
import style0 from "./LocaleEditDialog.vue?vue&type=style&index=0&id=558a7815&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a7815",
  null
  
)

export default component.exports